import { httpGet, httpPut } from '../httpCalls';
import { createAppearanceGlobalAssets, resetAppearanceGlobalAssets } from '../../actions/appearanceGlobalAssetsActions';
import { createSession } from '../../actions/sessionActions';
import { resetBackgroundFile } from '../../actions/backgroundFileActions';
import { resetDownloadableFile } from '../../actions/downloadableFileActions';
import { reloadError, resetError } from '../../actions/errorActions';
/* eslint-disable import/prefer-default-export */


export const mapDispatchToProps = (dispatch) => ({
  resetForm: () => dispatch(resetError()),
  getItem: (appId, areaId) => {
    dispatch(resetAppearanceGlobalAssets());
    dispatch(resetBackgroundFile());
    dispatch(resetDownloadableFile());

    return httpGet(`${appId}/${areaId}/appearance`).then((appearanceContent) => {
      dispatch(createAppearanceGlobalAssets(appearanceContent));
      dispatch(createSession({ appearanceGlobalAssetId: parseInt(appearanceContent.id, 10) }));
    }, (error) => {
      dispatch(reloadError(error));
      return Promise.reject(error);
    });
  },
  saveItem: (session, data) => {
    if (session.appearanceGlobalAssetId) {
      return httpPut(`appearance/${session.appearanceGlobalAssetId}`,
        data.appearanceGlobalAsset);
    }
    return null;
  },
});
